import CryptoJS from "crypto-js";

const HASH_KEY = process.env.REACT_APP_HASH_KEY;

export const getPayloadHash = (body: any) => {
  if (!body) return "";

  // create a shallow copy
    let hashBody = { ...body };
    
    // if file objects exist, remove them from hash calculation
    if (hashBody.light instanceof File || hashBody.light instanceof Blob) {
        delete hashBody.light;
    }
    if (hashBody.dark instanceof File || hashBody.dark instanceof Blob) {
        delete hashBody.dark;
    }
    if (hashBody.dark_logo instanceof File || hashBody.dark_logo instanceof Blob) {
        delete hashBody.dark_logo;
    }
    if (hashBody.light_logo instanceof File || hashBody.light_logo instanceof Blob) {
        delete hashBody.light_logo;
    }
    if (hashBody.file instanceof File || hashBody.file instanceof Blob) {
        delete hashBody.file;
    }
    
  // Sort keys alphabetically, convert objects to JSON string
  const sortedEntries = Object.entries(hashBody)
    .map(([key, value]) => [
      key,
      typeof value === "object" && value !== null ? JSON.stringify(value) : String(value),
    ])
    .sort(([a], [b]) => a.localeCompare(b));

  const sortedObj = Object.fromEntries(sortedEntries);
    //console.log("sortedObj=====>", sortedObj)
  // Build query string and decode
  const params = new URLSearchParams(sortedObj).toString();
  const decodedString = decodeURIComponent(params);

  // Append HASH_KEY and get MD5 hash
  const stringToHash = decodedString + HASH_KEY;
  return CryptoJS.MD5(stringToHash).toString();
};

 